@use "../../../../../styles/Constants.scss" as Constants;

.reasonInput {
	margin-top: Constants.$val-spacing-m;
}
